function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 256,
  fill: "#ffd93b"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4c534",
  d: "M512 256c0 141.44-114.64 256-256 256-80.48 0-152.32-37.12-199.28-95.28 43.92 35.52 99.84 56.72 160.72 56.72 141.36 0 256-114.56 256-256 0-60.88-21.2-116.8-56.72-160.72C474.8 103.68 512 175.52 512 256z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#3e4347"
}, /*#__PURE__*/React.createElement("path", {
  d: "M332.432 384.8c0 7.472-5.968 13.328-13.328 13.328H192.912c-7.36 0-13.328-5.872-13.328-13.328 0-7.36 5.968-13.328 13.328-13.328h126.192c7.344 0 13.328 5.968 13.328 13.328zM111.808 261.68c6.256-3.68 24.768 16.16 53.84 17.248 30.096 1.12 47.584-20.928 53.84-17.248 7.792 2.672-2.832 53.552-53.84 53.744-50.992-.192-61.632-51.072-53.84-53.744z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#e9b02c",
  d: "M99.808 239.312c-5.808-.928-9.776-6.4-8.832-12.224.944-5.808 6.32-9.792 12.224-8.832 59.968 9.632 78.192-33.2 78.368-33.632 2.208-5.456 8.416-8.08 13.904-5.856 5.456 2.224 8.08 8.448 5.856 13.904-12.032 29.472-49.824 54.944-101.52 46.64z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#3e4347",
  d: "M400.192 261.68c-6.256-3.68-24.768 16.16-53.84 17.248-30.096 1.12-47.584-20.928-53.84-17.248-7.792 2.672 2.832 53.552 53.84 53.744 50.992-.192 61.632-51.072 53.84-53.744z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#e9b02c",
  d: "M310.672 192.656c-2.224-5.456.4-11.68 5.856-13.904 5.44-2.224 11.648.384 13.888 5.808.8 1.92 19.12 43.216 78.384 33.696 5.872-.96 11.296 3.024 12.224 8.832.928 5.824-3.024 11.296-8.832 12.224-51.328 8.256-89.392-16.912-101.52-46.656z"
});

var SvgReportFailed = function SvgReportFailed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportFailed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report-failed.8417d964.svg";
export { ForwardRef as ReactComponent };